import { ParameterizedRemoteData } from "../Infra/RemoteData";
import { UserPermissions, UserType } from "healthex-common/user.dtos";
export class ConsentConfigManager {
    constructor(authManager, invalidationManager, consentConfigService, provisioningService) {
        this.authManager = authManager;
        this.invalidationManager = invalidationManager;
        this.consentConfigService = consentConfigService;
        this.provisioningService = provisioningService;
        this.consentConfig = new ParameterizedRemoteData(this.invalidationManager, () => this.authManager.orgId, (orgId) => this.getConsentConfig(orgId));
    }
    async getConsentConfig(organizationId) {
        if (organizationId &&
            ((this.authManager.userType === UserType.PATIENT && this.authManager.patientOrgType === UserType.HEALTHCARE_ORGANIZATION) ||
                (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION &&
                    this.authManager.permissions.includes(UserPermissions.RESEARCH_ADMIN)) ||
                this.authManager.userType === UserType.SCREENSHOT_USER)) {
            const result = await this.consentConfigService.getConsentConfig(organizationId);
            return result;
        }
        else {
            return null;
        }
    }
    async updateConsentConfig(consentConfig) {
        const organizationId = this.authManager.orgId;
        if (!organizationId)
            return;
        const currentConfig = await this.getConsentConfig(organizationId);
        if (!currentConfig) {
            throw new Error("Cannot find configuration to update");
        }
        const resolvedConfig = { ...currentConfig, ...consentConfig };
        await this.consentConfigService.updateConsentConfig(organizationId, resolvedConfig);
        await this.consentConfig.waitForReload();
    }
}
